import LoadingBootstrap from './LoadingBootstrap'

export default LoadingBootstrap
